import React from "react";
import { Button, Empty, Space, Switch } from "antd";
import confirmBox from "../../CoreComponents/confirmBox";
import { deleteSection, updateSection } from "./api";
import { sectionPath } from "./bannerPaths";
import { HiddenTag, ListRow, WindowTags } from "./bannerTags";
import { notify } from "./notify";

export default function SectionList({ sections, onChanged, onEdit, franchiseId, history }) {
  const toggle = async (section, on) => {
    if (notify(await updateSection(section.id, { isActive: on }), on ? "Section on" : "Section off")) onChanged();
  };
  const remove = (section) =>
    confirmBox({
      title: `Delete this section and its ${section.banner_count} banners?`,
      yesLabel: "Delete",
      onYes: async () => notify(await deleteSection(section.id), "Section deleted") && onChanged(),
    });
  if (!sections.length) return <Empty description="No sections yet" />;
  return sections.map((section) => (
    <ListRow key={section.id}>
      <img src={section.logo} alt="" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
      <div style={{ flex: 1, minWidth: 160 }}>
        <strong>{section.title}</strong>
        <div className="text-muted">{section.banner_count} banners</div>
      </div>
      <WindowTags section={section} />
      <HiddenTag reason={section.hidden_now} />
      <Switch checked={section.is_active} onChange={(on) => toggle(section, on)} />
      <Space>
        <Button type="primary" onClick={() => history.push(sectionPath(section, franchiseId))}>Open</Button>
        <Button onClick={() => onEdit(section)}>Edit</Button>
        <Button danger onClick={() => remove(section)}>Delete</Button>
      </Space>
    </ListRow>
  ));
}
